const getOptionName = (option, product) => {
  let name = option?.name
    ? `${option.id} - ${option.name}`
    : `${option.id} - Option`;

  if (product) {
    name = `${option.id} - ${product.art_des_cmpy}`;
  }

  if (option?.title) {
    name = `${option.id} - ${option.title}`;
  }

  return name;
};

export default getOptionName;
